import FlashcardsAPI from "@/services/api/flashcards"
import { useMutation } from "@tanstack/react-query"

const useSaveConfidenceIndex = () => {
  const mutation = useMutation({
    mutationKey: ["save-confidence-index"],
    mutationFn: FlashcardsAPI.saveConfidenceIndex,
  })
  return mutation
}

export default useSaveConfidenceIndex
